<div class="loader-container">
  <div class="loader-landscrap">
    <div class="loader">Loading...</div>  
  </div>
</div>
